module.exports = __webpack_public_path__ + "static/media/image_part_002.e7b78976.jpg";